import uuid from '../utils/uuid';
import md5 from 'js-md5';
import 'isomorphic-fetch';
import cookies from 'js-cookie';
import { getHeader } from '../utils';
import showCountdownMessage from '../utils/showCountdownMessage';
import getPlatform, { platformEnum } from '../utils/getPlatform';
import getDomain from '../utils/getDomain';
import redirectTo from '../utils/redirectTo';
import { message } from 'antd';
export interface FResult<T> {
  status: string;
  data?: T;
  errMsg?: string;
  errCode?: number;
  errorCode?: string;
  errorMsg?: string;
  content?: T;
}

let defaultFetchHeaders: any = null;
let secretKey = '';

const getDefaultFetchHeaders = () => {
  if (defaultFetchHeaders) return defaultFetchHeaders;
  const {
    appId,
    appVersion,
    appClient,
    appStage,
    appGwVersion,
    appSecrerKey,
    appDeviceid,
  } = getHeader();
  console.log(getHeader(), 'getDefaultFetchHeaders==>');
  // const client = cookies.get("focus-team-id") || 'WEB';
  defaultFetchHeaders = 1;
  defaultFetchHeaders = {
    'x-app': appId,
    'x-app-version': appVersion,
    'x-client': appClient,
    'x-did': appDeviceid,
    'x-gw-version': appGwVersion,
    'x-stage': appStage,
  };
  secretKey = appSecrerKey || '';
  return defaultFetchHeaders;
};

const getFetchUrl = (stage: string, api: string, requestUrl = '') => {
  if (requestUrl) {
    return `${requestUrl}/${api}`;
  }
  if (stage === 'PROD') {
    return `https://jzb.beijing.${
      window.location.host.includes('.egov') ? 'e' : ''
    }gov.cn/janus/${api}`;
  }
  let env = stage.toLowerCase();
  if (
    location.host.includes('-test') ||
    process.env.NODE_ENV === 'development'
  ) {
    env = 'test';
  }
  if (location.host.includes('-pre')) {
    env = 'pre';
  }
  return `https://jzb-${env}.jdcloud.com/janus/${api}`;
};

const getXSign = (headers: any) => {
  const tempString = `${headers['x-gw-version']}&${
    headers['x-app']
  }&${secretKey}&${headers['x-api']}&${headers['x-ts']}&${headers['x-nonce']}&${
    headers['x-client']
  }${headers['x-content-md5'] ? '&' + headers['x-content-md5'] : ''}`;
  return md5(tempString);
};

const handleTokenExpired = (requestResult: any, returnUrl?: any) => {
  const isDesktop = getPlatform() === platformEnum.ELECTRON;
  if (isDesktop) {
    const focusToken =
      cookies.get('joySpace-focus-token') || cookies.get('focus-token');
    // @ts-ignore
    window?.FocusSDK?.getAuthInfo((userData: any) => {
      if (!focusToken || focusToken !== userData.accessToken) {
        cookies.set('joySpace-focus-token', userData.accessToken, {
          domain: getDomain(window?.location.host),
        });
        cookies.set('focus-token', userData.accessToken, {
          domain: getDomain(window?.location.host),
        });
      }
    });
  }
  const { ssoLoginUrl, handleToken } = getHeader();
  if (handleToken) {
    showCountdownMessage({
      content: '长时间未操作，即将重新加载文档内容',
      duration: 2,
      callback: () =>
        isDesktop
          ? window.location.reload()
          : redirectTo(ssoLoginUrl as string),
    });
  } else {
    message.error('token已失效');
  }
};

export class FError {
  code: number | undefined;
  errCode: number | undefined;
  msg: string;
  errMsg: string;
  constructor(msg: string, code?: number, extra?: Object) {
    this.msg = msg;
    this.code = code;
    this.errCode = code;
    this.errMsg = msg;
    if (extra) {
      if (Object.keys(extra).length !== 0) {
        Object.keys(extra).forEach(item => {
          // @ts-ignore
          this[item] = extra[item];
        });
      }
    }
  }
  String() {
    return `[${this.errCode}] ${this.errMsg}`;
  }
}
export const ErrorNoResult = new FError(
  'Can not fetch any result without errors',
  1000
);
process.on('unhandledRejection', error => {
  console.log('unhandledRejection', error);
});
async function Fetch<T>(
  options: any = {}
): Promise<[T | null, FError | null, FResult<T> | null, any]> {
  const headers = {
    ...getDefaultFetchHeaders(),
    'x-token':
      cookies.get('joySpace-focus-token') || cookies.get('focus-token') || '',
    'x-team-id': cookies.get('focus-team-id') || '',
    ...(options['headers'] || {}),
    'x-nonce': uuid(),
    'x-ts': new Date().getTime(),
    'x-api': options.api,
    mode: 'cors',
    'content-type': 'application/json',
    accept: 'application/json',
  };
  if (options?.noContentType) {
    delete headers['content-type'];
  }
  const data = JSON.stringify({ ...(options.body || options.query || {}) });
  if (options.method === 'POST') {
    options.body = data;
  }
  headers['x-content-md5'] = md5(data);
  const sign = getXSign(headers);
  headers['x-sign'] = sign;
  const { requestUrl } = getHeader();
  let fetchUrl = getFetchUrl(
    headers['x-stage'] as string,
    (options.url || options.api) as string,
    requestUrl
  );
  // let fetchUrl = getFetchUrl('test', options.api as string);
  const resp = await fetch(fetchUrl, {
    ...options,
    headers,
  });
  const result = await resp.json();
  if (result.errorCode === '0' || result.code === '200') {
    return [result.data ?? result.content, null, result, resp.headers];
  } else if (
    result.errCode === 401 ||
    result.code === '401' ||
    result.errorCode === '0002'
  ) {
    // 0002是通讯录那边token失效代码
    handleTokenExpired(result, options.returnUrl);
    return [
      null,
      new FError(
        result.errMsg || result.status || result.errorMsg,
        result.errCode || result.code || result.errorCode,
        { errResolved: true }
      ),
      result,
      resp.headers,
    ];
  } else {
    return [
      null,
      new FError(
        result.errMsg || result.status || result.gw_echo, // gw_echo 通讯录那边错误信息
        result.errCode || result.code || result.gw_code // gw_code 通讯录那边错误代码
      ),
      result,
      resp.headers,
    ];
  }
}
export default Fetch;

export async function uploadFetch<T>(
  options: any = {}
): Promise<[T | null, FError | null, FResult<T> | null, any]> {
  const headers = {
    ...getDefaultFetchHeaders(),
    'x-token':
      cookies.get('joySpace-focus-token') || cookies.get('focus-token') || '',
    'x-team-id': cookies.get('focus-team-id') || '',
    ...(options['headers'] || {}),
    'x-nonce': uuid(), 
    'x-ts': new Date().getTime(),
    'x-api': options.api,
    mode: 'cors',
    'content-type': 'application/json',
    accept: 'application/json',
  };
  if (options?.noContentType) {
    delete headers['content-type'];
  }
  let data;
  const isFormData = options?.noContentType && options.body instanceof FormData; // 判断body是否为formData
  if (isFormData) {
    data = options.body;
  } else {
    data = JSON.stringify({ ...(options.body || options.query || {}) });
  }
  if (options.method === 'POST') {
    options.body = data;
  }
  headers['x-content-md5'] = md5(
    isFormData ? JSON.stringify({ ...data }) : data
  );
  const sign = getXSign(headers);
  headers['x-sign'] = sign;
  const { requestUrl } = getHeader();
  let fetchUrl = getFetchUrl(
    headers['x-stage'] as string,
    (options.url || options.api) as string,
    requestUrl
  );
  // let fetchUrl = getFetchUrl('test', options.api as string);
  const resp = await fetch(fetchUrl, {
    ...options,
    headers,
  });
  const result = await resp.json();
  if (result.errorCode === '0' || result.code === '200') {
    return [result.data ?? result.content, null, result, resp.headers];
  } else if (
    result.errCode === 401 ||
    result.code === '401' ||
    result.errorCode === '0002'
  ) {
    // 0002是通讯录那边token失效代码
    handleTokenExpired(result, options.returnUrl);
    return [
      null,
      new FError(
        result.errMsg || result.status || result.errorMsg,
        result.errCode || result.code || result.errorCode,
        { errResolved: true }
      ),
      result,
      resp.headers,
    ];
  } else {
    return [
      null,
      new FError(
        result.errMsg || result.status || result.gw_echo, // gw_echo 通讯录那边错误信息
        result.errCode || result.code || result.gw_code // gw_code 通讯录那边错误代码
      ),
      result,
      resp.headers,
    ];
  }
}